/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Backend_Development_Harden_Detail6Inputs */

const en_svc_backend_development_harden_detail6 = /** @type {(inputs: Svc_Backend_Development_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CI-ready deploy, documentation, and production hardening.`)
};

const ar_svc_backend_development_harden_detail6 = /** @type {(inputs: Svc_Backend_Development_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نشر جاهز لـ CI وتوثيق وتحصين للإنتاج.`)
};

const bn_svc_backend_development_harden_detail6 = /** @type {(inputs: Svc_Backend_Development_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CI-রেডি ডিপ্লয়, ডকুমেন্টেশন ও প্রোডাকশন হার্ডেনিং।`)
};

const de_svc_backend_development_harden_detail6 = /** @type {(inputs: Svc_Backend_Development_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CI-bereite Bereitstellung, Dokumentation und Produktionshärtung.`)
};

const es_svc_backend_development_harden_detail6 = /** @type {(inputs: Svc_Backend_Development_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deploy listo para CI, documentación y refuerzo para producción.`)
};

const fr_svc_backend_development_harden_detail6 = /** @type {(inputs: Svc_Backend_Development_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déploiement, documentation et renforcement de la production prêts pour CI.`)
};

const pt_svc_backend_development_harden_detail6 = /** @type {(inputs: Svc_Backend_Development_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Implantação, documentação e proteção de produção prontas para CI.`)
};

const zh_svc_backend_development_harden_detail6 = /** @type {(inputs: Svc_Backend_Development_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CI 就绪的部署、文档和生产加固。`)
};

const tr_svc_backend_development_harden_detail6 = /** @type {(inputs: Svc_Backend_Development_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CI'ya hazır deploy, dokümantasyon ve production hardening.`)
};

const ru_svc_backend_development_harden_detail6 = /** @type {(inputs: Svc_Backend_Development_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CI-ready деплой, документация и прод-харденинг.`)
};

const pl_svc_backend_development_harden_detail6 = /** @type {(inputs: Svc_Backend_Development_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wdrożenie gotowe do obsługi CI, dokumentacja i wzmocnienie produkcyjne.`)
};

/**
* | output |
* | --- |
* | "CI-ready deploy, documentation, and production hardening." |
*
* @param {Svc_Backend_Development_Harden_Detail6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_backend_development_harden_detail6 = /** @type {((inputs?: Svc_Backend_Development_Harden_Detail6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Backend_Development_Harden_Detail6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_backend_development_harden_detail6(inputs)
	if (locale === "bn") return bn_svc_backend_development_harden_detail6(inputs)
	if (locale === "de") return de_svc_backend_development_harden_detail6(inputs)
	if (locale === "es") return es_svc_backend_development_harden_detail6(inputs)
	if (locale === "fr") return fr_svc_backend_development_harden_detail6(inputs)
	if (locale === "pt") return pt_svc_backend_development_harden_detail6(inputs)
	if (locale === "zh") return zh_svc_backend_development_harden_detail6(inputs)
	if (locale === "tr") return tr_svc_backend_development_harden_detail6(inputs)
	if (locale === "ru") return ru_svc_backend_development_harden_detail6(inputs)
	if (locale === "pl") return pl_svc_backend_development_harden_detail6(inputs)
	return en_svc_backend_development_harden_detail6(inputs)
});
export { svc_backend_development_harden_detail6 as "svc_backend-development_HARDEN_detail" }